import React, { useEffect, useState, useRef } from "react";
import { isEqual } from "lodash";

import { stateOpt } from "../../utilities/helpers";

import { OrganizationInformation } from "./OrganizationInformation";

// child component to parent components SignUp and Settings OrgInfoWrapper to be able to use same component
export default function OrganizationInformationWrapper({
  getOrgInfo,
  orgInfo,
  error,
  isReadOnly = false,
}) {
  const [org, setOrg] = useState({
    name: "",
    address: {
      address_1: "",
      city: "",
      zipcode: "",
      state: stateOpt[0].value,
    },
  });

  const addressRef = useRef("");

  // Apply server / parent data when it arrives or changes externally (not echoed user edits).
  useEffect(() => {
    if (!orgInfo) return;
    setOrg((prev) => (isEqual(prev, orgInfo) ? prev : orgInfo));
  }, [orgInfo]);

  /** Defer so we never call parent's setState during this component's render/updater. */
  const notifyParent = (next) => {
    queueMicrotask(() => getOrgInfo(next));
  };

  const setName = (e) => {
    const { name, value } = e.target;
    setOrg((prev) => {
      const next = { ...prev, [name]: value };
      notifyParent(next);
      return next;
    });
  };

  const handleAddress = (e) => {
    const { name, value } = e.target;
    setOrg((prevState) => {
      const next = {
        ...prevState,
        address: {
          ...prevState.address,
          [name]: value,
        },
      };
      notifyParent(next);
      return next;
    });
  };

  return (
    <OrganizationInformation
      org={org}
      setName={setName}
      handleAddress={handleAddress}
      error={error}
      isReadOnly={isReadOnly}
    />
  );
}
